import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, CalendarDays, Wallet, CalendarClock, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import useAttendanceReminder from "@/hooks/useAttendanceReminder";

const items = [
  { to: "/app", icon: LayoutDashboard, label: "Home", end: true },
  { to: "/app/calendar", icon: CalendarDays, label: "Calendar" },
  { to: "/app/salary", icon: Wallet, label: "Salary" },
  { to: "/app/leaves", icon: CalendarClock, label: "Leaves" },
];

export default function EmployeeLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  useAttendanceReminder();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-slate-100">
      <header className="glass sticky top-0 z-30 border-b border-slate-200 safe-top">
        <div className="max-w-md mx-auto px-4 h-14 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img src="/omsivo-logo.png" alt="Omsivo EMP" className="h-8 w-8 rounded-full" />
            <span className="font-head font-extrabold text-slate-900">Omsivo EMP</span>
          </div>
          <div className="flex items-center gap-3">
            <button data-testid="logout-button" onClick={handleLogout} className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-red-600 transition-colors">
              <LogOut className="h-4 w-4" /> Logout
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-md mx-auto px-4 py-5 pb-28">
        <Outlet />
      </main>

      <nav className="fixed bottom-0 left-0 right-0 z-30 glass border-t border-slate-200 safe-bottom">
        <div className="max-w-md mx-auto grid grid-cols-4">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={`nav-${it.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 py-2.5 text-xs font-medium transition-colors ${
                  isActive ? "text-blue-600" : "text-slate-400"
                }`
              }
            >
              <it.icon className="h-5 w-5" />
              {it.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
